export var JobFieldTechTimelineLabel;
(function (JobFieldTechTimelineLabel) {
    JobFieldTechTimelineLabel["jobCreated"] = "Job Created";
    JobFieldTechTimelineLabel["scheduledDate"] = "Scheduled Date";
    JobFieldTechTimelineLabel["workCompleted"] = "Work Completed";
    JobFieldTechTimelineLabel["workDetailsReceived"] = "Work Details Received";
    JobFieldTechTimelineLabel["workStarted"] = "Work Started";
})(JobFieldTechTimelineLabel || (JobFieldTechTimelineLabel = {}));
export const jobFieldTechChronicleLabelMap = {
    appointmentCompleted: JobFieldTechTimelineLabel.workStarted,
    appointmentScheduled: JobFieldTechTimelineLabel.scheduledDate,
    cancelled: JobFieldTechTimelineLabel.workCompleted,
    completed: JobFieldTechTimelineLabel.workCompleted,
    received: JobFieldTechTimelineLabel.jobCreated,
    withdrawn: JobFieldTechTimelineLabel.workCompleted,
    workDetailsReceived: JobFieldTechTimelineLabel.workDetailsReceived,
};
